import Icon from '../../components/Icon.vue'

Icon.register({"regular/calendar":{"width":448,"height":512,"paths":[{"d":"M400 64H352V12C352 5.4 346.6 0 340 0H300C293.4 0 288 5.4 288 12V64H160V12C160 5.4 154.6 0 148 0H108C101.4 0 96 5.4 96 12V64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V112C448 85.5 426.5 64 400 64zM394 464H54C50.7 464 48 461.3 48 458V160H400V458C400 461.3 397.3 464 394 464z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/calendar.js
// module id = null
// module chunks = 